var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"option-shape-wrapper"},_vm._l((_vm.data),function(item,index){return _c('li',{key:index},[_vm._v("\n        "+_vm._s(item.option_text)+"\n    ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }